import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

// Outbound MN-CMS messages (GP → MN-CMS, msgtype 59) for a pregnancy, with
// their ACK/lifecycle status (see MncmsOutboundMessageDTO.displayStatus).
export const useMncmsOutboundMessages = (pregnancyId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant") ?? "";

  return useQuery({
    queryKey: ["mncmsOutboundMessages", pregnancyId, tenantVal],
    queryFn: async () => {
      const axios = createAxiosInstance();
      const response = await axios.get(
        `${tenantVal}/mncms/outbound-messages/pregnancy/${pregnancyId}`
      );

      return response.data?.data ?? response.data;
    },
    enabled: !!pregnancyId && !!tenantVal,
  });
};
